import Machines_A from './Machines_A'
import Machines_B from './Machines_B'
import Machines_C from './Machines_C'
import Machines_D from './Machines_D'

const Machines = {
  A: Machines_A,
  B: Machines_B,
  C: Machines_C,
  D: Machines_D,
  E: [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  ],
  F: [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  ],
  G: [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  ]
}

export default Machines



// WEBPACK FOOTER //
// ./src/components/Machines.js